import Index from './Map'

export default {
  Index
}



// WEBPACK FOOTER //
// ./src/components/map/index.js